/** biome-ignore-all lint/suspicious/noConsole: server-side logs that will be handled by Vercel log drain */ // add our properties and format as JSON
const formatLogs = (message, params)=>JSON.stringify({
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE_NAME ?? 'frontend-next',
        env: process.env.NEXT_PUBLIC_STAGE ?? 'local',
        version: process.env.NEXT_PUBLIC_VERSION ?? 'local',
        message,
        ...params
    });
/**
 * The server logger is a wrapper for the console.log that formats the log in a JSON format that DataDog likes
 */ export const serverLogger = {
    debug: (message, params, error)=>console.debug(formatLogs(message, params), error),
    info: (message, params, error)=>console.info(formatLogs(message, params), error),
    log: (message, params)=>console.log(formatLogs(message, params)),
    warn: (message, params, error)=>console.warn(formatLogs(message, params), error),
    error: (message, params, error)=>console.error(formatLogs(message, params), error)
};

//# sourceMappingURL=serverLogger.js.map